import { Member } from './colDefsMembersTable';

export const UserCell = (props: { data: Member }) => {
  return (
    <>
      <div className="flex align-items-center gap-3">
        <img
          className="border-circle"
          alt={props.data.fullName || props.data.email}
          src={props.data.imageUrl}
          width="40"
        />
        <div className="flex flex-column align-items-start justify-content-center">
          <span>{props.data.fullName}</span>
          <span>{props.data.email}</span>
        </div>
      </div>
    </>
  );
};
